export default __webpack_public_path__ + "static/media/rogers.da3c9658.jpg";